/**
 * WasmCrashChecker - Utility for checking WASM crash state
 * 
 * Extracted from TypesetterWorkerClient for better modularity and testability.
 * 
 * This utility provides functions for checking if WASM has crashed and should
 * refuse to process requests, preventing infinite retry loops.
 */

/**
 * Check if WASM has crashed and throw error if so
 * 
 * Validates that WASM is in a healthy state before processing requests.
 * Throws an error if WASM has crashed, preventing further processing.
 * 
 * @param wasmCrashed - Boolean indicating if WASM has crashed
 * @throws Error if WASM has crashed
 */
export function checkWasmCrashed(wasmCrashed: boolean): void {
  if (wasmCrashed) {
    console.error('🔥 [TypesetterWorkerClient] WASM crashed - refusing to process pagination');
    throw new Error('WASM engine crashed - please reload the page');
  }
}

/**
 * Log WASM crash state check
 * 
 * @param wasmCrashed - Boolean indicating if WASM has crashed
 * @returns True if WASM has crashed, false otherwise
 */
export function isWasmCrashed(wasmCrashed: boolean): boolean {
  if (wasmCrashed) {
    console.error('🔥 [TypesetterWorkerClient] WASM crashed - refusing to process');
  }
  return wasmCrashed;
}


